import { render, staticRenderFns } from "./kpi-task.vue?vue&type=template&id=254426fd"
import script from "./kpi-task.vue?vue&type=script&lang=js"
export * from "./kpi-task.vue?vue&type=script&lang=js"
import style0 from "./kpi-task.vue?vue&type=style&index=0&id=254426fd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports